(function() {
'use strict';

// Not at all happy about hard-coding these, but the api is still outstanding: API-827
const localAirports = (function() {
    if (TRPCONFIG.Domain.EnableStaticDepartureAirports) {
        return [
            { Title: 'London - All Airports', Code: 'LGW,LHR,STN' },
            { Title: 'London Gatwick (LGW)', Code: 'LGW' },
            { Title: 'London Heathrow (LHR)', Code: 'LHR' },
            { Title: 'London Stansted (STN)', Code: 'STN' },
            { Title: 'Birmingham (BHX)', Code: 'BHX' },
            { Title: 'Manchester (MAN)', Code: 'MAN' },
            { Title: 'Newcastle (NCL)', Code: 'NCL' },
            { Title: 'Glasgow (GLA)', Code: 'GLA' },
            { Title: 'Edinburgh (EDI)', Code: 'EDI' }
        ];
    }
    if (TRPCONFIG.Domain.DomainId === 2) {
        return [
            { Title: 'Belfast and Dublin - All Airports', Code: 'BFS,BHD,DUB' },
            { Title: 'Ireland - All Airports', Code: 'BHD,BFS,ORK,LDY,KIR,NOC,DUB,CFN,SNN' },
            { Title: 'Belfast City', Code: 'BHD' },
            { Title: 'Belfast International', Code: 'BFS' },
            { Title: 'Dublin', Code: 'DUB' },
            { Title: 'Cork', Code: 'ORK' },
            { Title: 'Derry', Code: 'LDY' },
            { Title: 'Donegal', Code: 'CFN' },
            { Title: 'Kerry', Code: 'KIR' },
            { Title: 'Knock', Code: 'NOC' },
            { Title: 'Shannon', Code: 'SNN' },
            //{ Title: 'Waterford', Code: 'WAT' },

            { Title: 'London - All Airports', Code: 'LGW,LHR,LTN,SEN,STN,LCY' },
            { Title: 'Midlands - All Airports', Code: 'BHX,EMA' },
            { Title: 'North West - All Airports', Code: 'LPL,MAN' },
            { Title: 'North East - All Airports', Code: 'DSA,HUY,LBA,MME,NCL' },
            { Title: 'South East - All Airports', Code: 'LGW,LHR,SOU' },
            { Title: 'South West - All Airports', Code: 'BOH,BRS,CWL,EXT,NQY,SOU' },
            { Title: 'Scotland - All Airports', Code: 'ABZ,EDI,GLA,INV,PIK' },

            { Title: 'Aberdeen (ABZ)', Code: 'ABZ' },
            { Title: 'Belfast City George Best (BHD)', Code: 'BHD' },
            { Title: 'Belfast International (BFS)', Code: 'BFS' },
            { Title: 'Birmingham (BHX)', Code: 'BHX' },
            { Title: 'Bournemouth (BOH)', Code: 'BOH' },
            { Title: 'Bristol (BRS)', Code: 'BRS' },
            { Title: 'Cardiff (CWL)', Code: 'CWL' },
            { Title: 'Derry (LDY)', Code: 'LDY' },
            { Title: 'Dublin (DUB)', Code: 'DUB' },
            { Title: 'Durham Tees Valley (MME)', Code: 'MME' },
            { Title: 'East Midlands (EMA)', Code: 'EMA' },
            { Title: 'Edinburgh (EDI)', Code: 'EDI' },
            { Title: 'Exeter (EXT)', Code: 'EXT' },
            { Title: 'Glasgow (GLA)', Code: 'GLA' },
            { Title: 'Glasgow Prestwick (PIK)', Code: 'PIK' },
            { Title: 'Guernsey (GCI)', Code: 'GCI' },
            { Title: 'Humberside (HUY)', Code: 'HUY' },
            { Title: 'Inverness (INV)', Code: 'INV' },
            { Title: 'Isle of Man (IOM)', Code: 'IOM' },
            { Title: 'Jersey (JER)', Code: 'JER' },
            { Title: 'Leeds (LBA)', Code: 'LBA' },
            { Title: 'Liverpool John Lennon (LPL)', Code: 'LPL' },
            { Title: 'London City (LCY)', Code: 'LCY' },
            { Title: 'London Gatwick (LGW)', Code: 'LGW' },
            { Title: 'London Heathrow (LHR)', Code: 'LHR' },
            { Title: 'London Luton (LTN)', Code: 'LTN' },
            { Title: 'London Southend (SEN)', Code: 'SEN' },
            { Title: 'London Stansted (STN)', Code: 'STN' },
            { Title: 'Manchester (MAN)', Code: 'MAN' },
            { Title: 'Newcastle (NCL)', Code: 'NCL' },
            { Title: 'Newquay (NQY)', Code: 'NQY' },
            { Title: 'Norwich (NWI)', Code: 'NWI' },
            { Title: 'Robin Hood Airport Doncaster (DSA)', Code: 'DSA' },
            { Title: 'Southampton (SOU)', Code: 'SOU' }
        ];
    }
    return [
        { Title: 'London - All Airports', Code: 'LGW,LHR,LTN,SEN,STN,LCY' },
        { Title: 'Midlands - All Airports', Code: 'BHX,EMA' },
        { Title: 'North West - All Airports', Code: 'LPL,MAN' },
        { Title: 'North East - All Airports', Code: 'DSA,HUY,LBA,MME,NCL' },
        { Title: 'South East - All Airports', Code: 'LGW,LHR,SOU' },
        { Title: 'South West - All Airports', Code: 'BOH,BRS,CWL,EXT,NQY,SOU' },
        { Title: 'Scotland - All Airports', Code: 'ABZ,EDI,GLA,INV,PIK' },
        { Title: 'Belfast and Dublin - All Airports', Code: 'BFS,BHD,DUB' },

        { Title: 'Aberdeen (ABZ)', Code: 'ABZ' },
        { Title: 'Belfast City George Best (BHD)', Code: 'BHD' },
        { Title: 'Belfast International (BFS)', Code: 'BFS' },
        { Title: 'Birmingham (BHX)', Code: 'BHX' },
        { Title: 'Bournemouth (BOH)', Code: 'BOH' },
        { Title: 'Bristol (BRS)', Code: 'BRS' },
        { Title: 'Cardiff (CWL)', Code: 'CWL' },
        { Title: 'Derry (LDY)', Code: 'LDY' },
        { Title: 'Dublin (DUB)', Code: 'DUB' },
        { Title: 'Durham Tees Valley (MME)', Code: 'MME' },
        { Title: 'East Midlands (EMA)', Code: 'EMA' },
        { Title: 'Edinburgh (EDI)', Code: 'EDI' },
        { Title: 'Exeter (EXT)', Code: 'EXT' },
        { Title: 'Glasgow (GLA)', Code: 'GLA' },
        { Title: 'Glasgow Prestwick (PIK)', Code: 'PIK' },
        { Title: 'Guernsey (GCI)', Code: 'GCI' },
        { Title: 'Humberside (HUY)', Code: 'HUY' },
        { Title: 'Inverness (INV)', Code: 'INV' },
        { Title: 'Isle of Man (IOM)', Code: 'IOM' },
        { Title: 'Jersey (JER)', Code: 'JER' },
        { Title: 'Leeds (LBA)', Code: 'LBA' },
        { Title: 'Liverpool John Lennon (LPL)', Code: 'LPL' },
        { Title: 'London City (LCY)', Code: 'LCY' },
        { Title: 'London Gatwick (LGW)', Code: 'LGW' },
        { Title: 'London Heathrow (LHR)', Code: 'LHR' },
        { Title: 'London Luton (LTN)', Code: 'LTN' },
        { Title: 'London Southend (SEN)', Code: 'SEN' },
        { Title: 'London Stansted (STN)', Code: 'STN' },
        { Title: 'Manchester (MAN)', Code: 'MAN' },
        { Title: 'Newcastle (NCL)', Code: 'NCL' },
        { Title: 'Newquay (NQY)', Code: 'NQY' },
        { Title: 'Norwich (NWI)', Code: 'NWI' },
        { Title: 'Robin Hood Airport Doncaster (DSA)', Code: 'DSA' },
        { Title: 'Southampton (SOU)', Code: 'SOU' }
    ];
})();

angular
    .module('TR')
    .service('autocompleter', autocompleter);

function autocompleter($http,
        $q,
        $filter,
        $route,
        globalisationService) {
    const domain = TRPCONFIG.Domain;
    const httpStatus = { BadRequest: 400 };
    let airports = null;

    const service = {
        lookup,
        initialDepartureAirports
    };

    function _filteredAirports(prefix) {
        if (airports) {
            const d = $q.defer();
            d.resolve({
                data: $filter('filter')(airports, prefix),
                prefix
            });
            return d.promise;
        }

        return $http.post('/api3/transfers/airports/get', {
            CultureCode: domain.CultureCode,
            DomainId: domain.DomainId
        }).then(function(result) {
            airports = result.data.Airports;
            return {
                data: $filter('filter')(airports, prefix),
                prefix
            };
        });
    }

    function lookup(type, prefix, filterFunction) {
        //Use filterFunction returned data as promise incase if it presents and ignore everything else.
        if (filterFunction) {
            return $q.when({
                data: filterFunction({ prefix }),
                prefix
            });
        }
        if (!type) {
            throw new Error('type have not been supplied');
        }
        return _lookup(type, prefix).then(result => {
            if (result && _.isArray(result.data)) {
                _.forEach(result.data, d => d.searchLookupType = type);
            }
            return result;
        });
    }

    function _autoCompleterApiCall(url, prefix) {
        return globalisationService.getSelectedRegionalContext()
            .then(regionalContext => $http.get(url + $.param({
                    TenantId: TRPCONFIG.Domain.TenantId,
                    PointOfSaleId: regionalContext.PointOfSale.Id,
                    CultureCode: regionalContext.Language.Code,
                    MaxResults: 15,
                    Term: prefix
                }), { ignoreErrors: true })
            );
    }

    function _getDepartureAirportsByPointOfSale(prefix) {
        return _autoCompleterApiCall('/api/flights/autocompleter/departureairports?', prefix);
    }

    function _lookup(type, prefix) {
        if (type === 'transfers') {
            return _filteredAirports(prefix);
        } else if (type === 'marhaba') {
            return $http.post('/api2/marhaba/airports/getairports', {
                CultureCode: domain.CultureCode,
                SearchTerm: prefix
            }).then(function(result) {
                return {
                    data: result.data.Airports,
                    prefix
                };
            });
        } else if (type === 'parking') {
            return $http
                .post('/api2/airportparking/airports/get')
                .then(result => {
                    const filteredResult = $filter('filter')(result.data.Airports, prefix);
                    return {
                        data: _.map(filteredResult, a => {
                            // Have to map `AirportCode` to `Code`
                            if (a.AirportCode) {
                                a.Code = a.AirportCode;
                                delete a.AirportCode;
                            }
                            return a;
                        }),
                        prefix
                    };
                });
        } else if (type === 'flights-departure' && TRPCONFIG.Domain.LimitDepartureAirportsToLocalOnly) {
            let airports = prefix ? $filter('filter')(localAirports, { Title: prefix }) : localAirports;
            airports = buildUpChildAirports(airports);
            return $q.when(mapDepartureAirports(airports, prefix));
        } else if (['flights-departure', 'flights-destination', 'flights'].indexOf(type) > -1) {
            if (TRPCONFIG.Domain.PointOfSaleAutocompleterEnabled) {
                return _getDepartureAirportsByPointOfSale(prefix).then(r => {
                    return mapDepartureAirports(r.data.d.map(a => {
                        return { Title: a.t, Code: a.v };
                    }), prefix);
                });
            }
            const postData = {
                SearchTerm: prefix,
                MaxResults: 15,
                CultureCode: domain.CultureCode,
                RestrictToFlightDestinations: false
            };
            return $http
                .post('/api2/flights/static/getdestinationairports', postData)
                .then(result => mapDepartureAirports(result.data.Airports, prefix));
        } else if (type === 'non-grouped-airports') {
            return _lookup('flights', prefix).then(res => {
                res.data = res.data.filter(airport => airport.Code.indexOf(',') === -1);
                return res;
            });
        } else if (type === 'businesscustomers') {
            return $http
                .get(`${TRPCONFIG.AutocompleterClientDomain}/api2/businesscustomers/get?${$.param({
                    DomainId: domain.DomainId,
                    MaxResults: 400,
                    MaxStringDistance: 4,
                    CultureCode: domain.CultureCode,
                    SearchTerm: prefix
                })}`)
                .then(function(result) {
                    return {
                        data: result.data,
                        prefix
                    };
                });
        } else if (type === 'travelAgents') {
            return $http
                .get(`${TRPCONFIG.AutocompleterClientDomain}/api2/travelagents/search?${$.param({
                    tenantId: TRPCONFIG.Domain.TenantId,
                    pageSize: 10,
                    searchQuery: prefix
                })}`, { ignoreErrors: true })
                .then(result => {
                    return {
                        data: result.data.map(t => { t.Title = t.Name; return t; }),
                        prefix
                    };
                }, error => {
                    if (error.status === httpStatus.BadRequest) {
                        return { data: [], prefix };
                    }
                });
        } else if ('attractions' === type) {
            return $http.post(`${TRPCONFIG.AutocompleterClientDomain}/api2/attractions/bookingfunnel/find`, {
                DestinationId: TRPCONFIG.Domain.DomainId,
                Fragment: prefix,
                TenantId: TRPCONFIG.Domain.TenantId
            }).then(function(result) {
                return {
                    data: result.data,
                    prefix
                };
            });
        } else if (type === 'resorts') {
            return _autoCompleterApiCall('/api/hotels/autocompleter/transferdestinations?', prefix)
                .then(function(result) {
                    if (result && result.data && result.data.d) {
                        return {
                            data: result.data.d.map(d => {
                                d.Title = d.t;
                                d.Code = d.v.i;
                                d.Type = d.v.t;
                                return d;
                            }),
                            prefix
                        };
                    }
                });
        } else if (type === 'userAccounts') {
            const nameParts = prefix.split(' ');
            const params = {
                tenantId: TRPCONFIG.Domain.TenantId,
                pageSize: 10,
                firstName: nameParts[0] || '',
                lastName: nameParts[1] || ''
            };
            return $http
                .get(`${TRPCONFIG.AutocompleterClientDomain}/api2/useraccounts/search?${$.param(params)}`)
                .then(function(result) {
                    if (result && result.data && result.data.Results) {
                        return {
                            data: result.data.Results.map(t => {
                                t.Title = `${t.FirstName} ${t.LastName}`;
                                return t;
                            }),
                        prefix
                    };
                }
            });
        }

        return $http
            .get(`${TRPCONFIG.AutocompleterClientDomain}/api/destinationsautocompleter/search?${$.param({
                SearchTerm: prefix,
                MaxResults: 15,
                CultureCode: domain.CultureCode,
                HolidaySearch: type === 'holidays',
                DomainId: TRPCONFIG.Domain.DomainId,
                v: TRPCONFIG.CurrentVersion
            })}`, { ignoreErrors: true })
            .then(function(result) {
                return {
                    data: result.data.Destinations,
                    prefix
                };
            });
    }

    function mapDepartureAirports(airports, prefix) {
        if ($route.current.noGroup) {
            airports =
                airports.filter(function removeGroups(cv) {
                    return cv.Code.indexOf(',') === -1;
                });
        }
        return {
            data: _.map(airports, a => {
                if (a.Title) {
                    a.ShortTitle = a.Title.indexOf(',') >= 0 ? a.Title.split(',')[0] : a.Title;
                }
                a.icon = 'flights';
                return a;
            }),
            prefix
        };
    }

    function initialDepartureAirports() {
        const airports = buildUpChildAirports(localAirports);
        return $q.when(mapDepartureAirports(airports, ''));
    }

    function buildUpChildAirports(airports) {
        let result = [];
        _.forEach(airports, a => {
            result.push(a);
            const codes = a.Code.split(',');
            if (codes.length > 1) {
                a.isGroup = true;
                _.forEach(codes, c => {
                    let match = _.find(localAirports, a => a.Code === c);
                    if (match) {
                        match = angular.copy(match);
                        match.isChild = true;
                        result.push(match);
                    } else {
                        console.log('match could not be found for ', a.Code);
                    }
                });
            }
        });
        result = result.filter(a => {
            if (a.isChild || a.isGroup) {
                return true;
            }
            return !_.some(result, aa => aa.isChild && aa.Code === a.Code);
        });
        return result;
    }

    return service;
}
})();
